<div class="modal-header">
  <h4 class="modal-title">
    {{ "common.passwordResetTitle1" | translate }}
    <br>
    {{ "signup.confirm.title" | translate }}
  </h4>
</div>
<div class="modal-body">

  <div class="inner-modal-body">
    <p>
      {{ message | translate }}
      <br>
      <b> {{ email }} </b>
    </p>
    <div class="__actions gs keep-lay">
      <div class="lay-left">
        <button class="btn btn-primary btn-sm btn-block" (click)="confirm()">
          {{ accept | translate }}
        </button>
      </div>
      <div class="lay-right">
        <button class="btn btn-secondary btn-secondary-outline btn-sm btn-block"
          (click)="activeModal.dismiss('Cross click')">
          {{ deny | translate }}
        </button>
      </div>
    </div>
  </div>
</div>